module.exports = __webpack_public_path__ + "media/images/projects/9-header-fa193f50eb0bf76b4b1ff9111ea1fd97.jpg";